require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/node_modules/strophejs-plugins/disco/strophe.disco.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/strophejs-plugins/disco/strophe.disco.js
 ** module id = 7
 ** module chunks = 0
 **/